<template>
  <div class="pay-button-container">

    <button
      id="payment-button"
      class="pay-online-button ml-3"
      :class="buttonConfig.colorClass"
      @click="payOnlineButton"
      :disabled="buttonConfig.disabled"
      v-loading="isLoading"
    >
      <span class="pay-online-button__text">
        {{ buttonConfig.text }}
        <i :class="buttonConfig.icon"></i>
      </span>
    </button>

    <div class="powered-by-container">
      <span class="powered-by-container__text">Powered by </span>
      <img class="icons-tools" src="@/assets/images/melio-logo-vector.svg" alt="" />
    </div>

    <button
      v-if="melioStatus === 'Pay Online'"
      v-loading="isLoading"
      @click="payOnlineButton"
      class="float-button"
      :class="buttonConfig.colorClass"
    >
      <i v-b-popover.hover.top="'Pay Online'" class="ion ion-card-sharp"></i>
    </button>

  </div>
</template>

<script>
import { warningMessage } from "../../../utils/ErrorMessages";

export default {
  name: "PayButton",
  props: {
    melioData: Array,
  },

  data() {
    return {
      tokenInfo: null,
      isLoading: false,
    };
  },

  created() {
    this.tokenInfo = this.$store.getters["login/getTokenInfo"];
  },

  computed: {
    melioStatus() {
      const { melio_payment_status: status, balance } = this.melioData[0];

      if (status === "Paid" && balance === 0) return "Paid";
      if (status === "Paid" && balance !== 0) return "In Progress";
      if (status === "In-progress") return "In Progress";
      if (status === "" && balance !== 0) return "Pay Online";

      return "Pay Online";
    },

    buttonConfig() {
      const config = {
        Paid: {
          text: "Paid",
          colorClass: "btn-pay",
          icon: "ion-checkmark-circle-outline",
          disabled: true,
        },
        "In Progress": {
          text: "In Progress",
          colorClass: "btn-progress",
          icon: "ion-hourglass-outline",
          disabled: true,
        },
        "Pay Online": {
          text: "Pay Online",
          colorClass: "btn-pay-online",
          icon: "ion-card-sharp",
          disabled: false,
        },
      };

      return config[this.melioStatus];
    },
  },

  methods: {
    async payOnlineButton() {
      if (this.melioStatus === "Pay Online") {
        this.isLoading = true;
        this.$store.commit("paymentHub/setNewLoadPaymentData", this.melioData);
        this.$router.push(`/payment-hub`);
        this.isLoading = false;
      } else {
        warningMessage("Info", "Unable to redirect to payment hub");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_themes' as *;
.float-button {
  background-color: $color-primary-company;
  color: $color-white;
  position: fixed;
  z-index: 999;
  bottom: 1vw;
  right: 3vw;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  margin-bottom: 0.6rem;
  text-align: center;
  transition: 0.3s;
  font-size: 22px;
  border: none;
}
.pay-button-container {
  display: flex;
  flex-direction: column;
  margin-top: 2%;
  align-items: flex-end;
}
.pay-online-button {
  width: 150px;
  border-radius: 15px;
  height: 40px;
  background: $color-primary-company;
  border: none;
  color: $color-white;
  &__text {
    font-size: 14px;
    font-weight: bold;
  }
  i {
    text-align: center;
  }
  @media (max-width: 500px) {
    margin-bottom: 5px;
  }
}
.powered-by-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -10px;
  margin-right: 4px;
  &__text {
    font-size: 12px;
    font-family: "Roboto", sans-serif;
    width: 75px;
    color: gray;
  }
}
.icons-tools {
  width: 50px;
  height: 50px;
}
.pay-online-button ::v-deep .el-loading-mask {
  border-radius: 13px;
}
.float-button ::v-deep .el-loading-mask {
  border-radius: 50px;
}

.btn-pay {
  background-color: #70c369;
}

.btn-progress {
  background-color: $color-border-container;
}

.btn-pay-online {
  background-color: $color-primary-company;
}
</style>
